/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Image } from 'react-bootstrap'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBars,
  faVolumeXmark,
  faVolumeHigh,
} from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function MoveinVideoPreview({
  srcs,
  isMediaVisible,
  redirectVideo,
  redirectImage,
}) {
  const containerRef = useRef(null)
  const rightSwiperRef = useRef(null)
  const [rightIndex, setRightIndex] = useState(0)
  const wheelLockRef = useRef(false)
  const videoRef = useRef(null)
  const [isMuted, setIsMuted] = useState(true)

  const backgroundImg = srcs.find((s) => s.label === 'Background Img')
  const leftVideo = srcs.find((s) => s.label === 'Left Video')
  const rightImg1 = srcs.find((s) => s.label === 'Right Img 1')
  const rightImg2 = srcs.find((s) => s.label === 'Right Img 2')
  const rightImg3 = srcs.find((s) => s.label === 'Right Img 3')

  const getPreviewURL = (file) => {
    if (!file) return ''
    if (file instanceof File) return URL.createObjectURL(file)
    if (typeof file === 'string' && file.startsWith('blob:')) return file
    return `/api/file/${file}`
  }

  const handleWheel = (e) => {
    if (wheelLockRef.current) return

    wheelLockRef.current = true
    setTimeout(() => {
      wheelLockRef.current = false
    }, 500)

    if (!rightSwiperRef.current) return

    const rightSwiper = rightSwiperRef.current.swiper

    if (e.deltaY > 0) {
      rightSwiper.slideNext()
    } else if (e.deltaY < 0) {
      rightSwiper.slidePrev()
    }
  }

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
      onWheel={handleWheel}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '2%' }}
        />
        <div style={{ position: 'relative' }}>
          <div
            className="border-bottom mb-3 d-flex"
            style={{ width: '240px', height: '55px', zIndex: '0' }}
          >
            <div className="w-80 m-auto ms-auto">
              <Image src={wavenet_logo} className="w-75 ps-3" />
            </div>
            <div className="w-20 m-auto ms-auto d-flex">
              <FontAwesomeIcon icon={faBars} className="text-end" />
            </div>
          </div>
          <div className="text-title" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-ban1" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line2" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
        </div>
      </div>

      <div
        style={{
          objectFit: 'cover',
          height: 'auto',
          position: 'absolute',
          bottom: '12%',
          width: '240px',
          zIndex: '1000',
        }}
      >
        <div
          ref={containerRef}
          className="position-relative"
          style={{
            width: '240px',
            minHeight: 'auto',
            margin: '0 auto',
          }}
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      {/* 背景區塊容器 */}
      <div
        style={{
          position: 'absolute',
          bottom: '11%',
          width: '240px',
          zIndex: 1000,
        }}
      >
        {/* 背景圖片 */}
        {isMediaVisible && backgroundImg?.file && (
          <>
            <img
              src={getPreviewURL(backgroundImg.file)}
              alt="BackgroundImg"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
              }}
            />
            <CIIcon />
          </>
        )}

        {/* LeftVideo */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '50%',
            height: '100%',
            zIndex: 1100,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div style={{ position: 'relative', width: '100%', height: 'auto' }}>
            <video
              ref={videoRef}
              autoPlay
              loop
              muted={isMuted}
              playsInline
              onClick={() => {
                if (redirectVideo) window.open(redirectVideo, '_blank')
              }}
              style={{
                width: '100%',
                height: 'auto',
                objectFit: 'cover',
                cursor: redirectVideo ? 'pointer' : 'default',
              }}
            >
              <source
                src={getPreviewURL(leftVideo.file)}
                type={leftVideo.file?.type || 'video/mp4'}
              />
              <track kind="captions" srcLang="zh" src="" label="" default />
            </video>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation()
                setIsMuted((prev) => {
                  const newMuted = !prev
                  if (videoRef.current) videoRef.current.muted = newMuted
                  return newMuted
                })
              }}
              style={{
                position: 'absolute',
                left: '0px',
                bottom: '5px',
                zIndex: 1500,
                backgroundColor: 'rgba(0,0,0,0.5)',
                borderRadius: '50%',
                width: '25px',
                height: '25px',
                color: 'white',
                fontSize: '14px',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              <FontAwesomeIcon icon={isMuted ? faVolumeXmark : faVolumeHigh} />
            </button>
          </div>
        </div>

        {/* Swiper 右側輪播 */}
        <div
          role="presentation"
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '50%',
            height: '100%',
            zIndex: 1100,
          }}
          onClick={() => {
            if (redirectImage) window.open(redirectImage, '_blank')
          }}
        >
          <Swiper
            ref={rightSwiperRef}
            loop
            modules={[Autoplay]}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            slidesPerView={1}
            onSlideChange={(swiper) => setRightIndex(swiper.realIndex)}
          >
            {[rightImg1, rightImg2, rightImg3].map(
              (img, i) =>
                img?.file && (
                  <SwiperSlide key={`right-${i}`}>
                    <img
                      src={getPreviewURL(img.file)}
                      alt={`Right ${i + 1}`}
                      className={`movein-slide-img ${
                        rightIndex === i ? 'slide-in-right' : 'slide-out-right'
                      }`}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    />
                  </SwiperSlide>
                )
            )}
          </Swiper>
        </div>
      </div>
    </div>
  )
}

MoveinVideoPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
  isMediaVisible: PropTypes.bool.isRequired,
  redirectVideo: PropTypes.string,
  redirectImage: PropTypes.string,
}

MoveinVideoPreview.defaultProps = {
  srcs: [],
  redirectVideo: '',
  redirectImage: '',
}

export default MoveinVideoPreview
